<div class="callback-container">
  <div class="callback-content">
    <img src="./assets/favicons/cropped-explain-favicon-192x192.png" alt="Explain" width="48" height="48" />
    <h3 *ngIf="processing">{{ 'crm.callback.processing' | translate }}</h3>
    <h3 *ngIf="!processing && status === 'success'">{{ 'crm.callback.success' | translate }}</h3>
    <h3 *ngIf="!processing && status === 'error'">{{ 'crm.callback.error' | translate }}</h3>
    <div class="spinner" *ngIf="processing"></div>
    <div *ngIf="!processing && status === 'error' && errorMessage" class="error-text">{{ errorMessage }}</div>
    <div *ngIf="!processing" class="hint">{{ 'crm.callback.hint' | translate }}</div>
  </div>
</div>
